import { createClass as _createClass, classCallCheck as _classCallCheck, defineProperty as _defineProperty } from '../_virtual/_rollupPluginBabelHelpers.js';
import '../node_modules/.pnpm/core-js@3.27.1/node_modules/core-js/modules/es.array.iterator.js';
import '../node_modules/.pnpm/core-js@3.27.1/node_modules/core-js/modules/es.map.constructor.js';
import '../node_modules/.pnpm/core-js@3.27.1/node_modules/core-js/modules/es.object.to-string.js';
import '../node_modules/.pnpm/core-js@3.27.1/node_modules/core-js/modules/es.string.iterator.js';
import '../node_modules/.pnpm/core-js@3.27.1/node_modules/core-js/modules/web.dom-collections.iterator.js';

function parseJSON(value) {
  return value === 'undefined' ? undefined : JSON.parse(value);
}

/**
 * @description sessionStorage가 에러를 throw 하는 경우들
 * 1. 세션스토리지 용량 초과
 * @see http://dev-test.nemikor.com/web-storage/support-test/
 * - 브라우저마다 차이 존재하나 평균적으로 5M 용량
 * 2. Safari private mode에서 sessionStorage.setItem() 실행 시 throw
 * 3. SecurityError
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/sessionStorage#exceptions
 * - Safari 에서 disabled cookie 설정 등
 */
function goodTry(tryFn) {
  try {
    return tryFn();
  } catch (error) {
    var _message;
    /** IGNORE */
    // eslint-disable-next-line no-console
    console.error("[useSessionStorage] ".concat((_message = error === null || error === void 0 ? void 0 : error.message) !== null && _message !== void 0 ? _message : 'Error occurred in window.sessionStorage.'));
    return undefined;
  }
}
var InMemoryData = /*#__PURE__*/function () {
  function InMemoryData() {
    _classCallCheck(this, InMemoryData);
    _defineProperty(this, "inMemoryData", new Map());
  }
  _createClass(InMemoryData, [{
    key: "has",
    value: function has(key) {
      return this.inMemoryData.has(key);
    }
  }, {
    key: "set",
    value: function set(key, value) {
      this.inMemoryData.set(key, value);
    }
  }, {
    key: "get",
    value: function get(key) {
      return this.inMemoryData.get(key);
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      this.inMemoryData.delete(key);
    }
  }]);
  return InMemoryData;
}();

export { InMemoryData, goodTry, parseJSON };
